import * as THREE from 'three'

import Experience from '../Experience.js'
import Environment from './Environment.js'
import Floor from './Floor.js'
import Fox from './Fox.js'
import Functions from './Functions.js'

export default class World
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.sizes=this.experience.sizes
        this.camera = this.experience.camera
        this.down=false

        // Wait for resources
        this.resources.on('ready', () =>
        {
            // Setup
            this.floor = new Floor()
            this.fox = new Fox()
            this.environment = new Environment()
            this.functions = new Functions()
        })

        // window.addEventListener('mousedown',()=>{
        //     document.body.style.cursor="grabbing"
        //     this.down=true
        // })
        // window.addEventListener('mouseup',()=>{
        //     this.down=false
        //     document.body.style.cursor="grab"

        // })
        // window.addEventListener('mousemove',()=>{
        //     if(this.down==true){
        //     document.body.style.cursor="grabbing"

        //     }if(this.down==false){
        //     document.body.style.cursor="grab"

        //     }
        // })
    }

    
    update()
    {

        if(this.fox)
            this.fox.update()
    }
}